import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { ls } from '@ezugi/utils';

import { MEDIA } from '../../constants';
import { type MediaActions } from '../actions/media';

export type Volume = {
    value: number;
    muted: boolean;
}

const defaultVolume: Volume = { value: 50, muted: false };

const getInitialVolume = (): Volume => {
  const [ err, localStorageVolume ] = ls.get(MEDIA.VOLUME);

  if (err || typeof localStorageVolume?.value === 'undefined') {
    return defaultVolume;
  }

  return localStorageVolume;
};

const initialState = {
  volume: getInitialVolume(),
  gameSounds: true,
  backgroundMusic: false,
  videoStreamSound: true,
};

const mediaSliceBuilder = (actions: { mediaActions: MediaActions }) => {
  const { volume, sound, music, videoStreamSound, autoplaymute } = actions.mediaActions;

  return createSlice({
    name: 'media',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder.addCase(volume.set, (state, { payload }: PayloadAction<Volume>) => ({
        ...state,
        volume: payload,
      }));
      builder.addCase(sound.toggle, (state) => ({
        ...state,
        gameSounds: !state.gameSounds,
      }));
      builder.addCase(sound.set, (state, { payload }: PayloadAction<boolean>) => ({
        ...state,
        gameSounds: payload,
      }));
      builder.addCase(music.toggle, (state) => ({
        ...state,
        backgroundMusic: !state.backgroundMusic,
      }));
      builder.addCase(music.set, (state, { payload }: PayloadAction<boolean>) => ({
        ...state,
        backgroundMusic: payload,
      }));
      builder.addCase(videoStreamSound.toggle, (state) => ({
        ...state,
        videoStreamSound: !state.videoStreamSound,
      }));
      builder.addCase(videoStreamSound.set, (state, { payload }: PayloadAction<boolean>) => ({
        ...state,
        videoStreamSound: payload,
      }));
      builder.addCase(autoplaymute.set, (state, { payload }: PayloadAction<boolean>) => ({
        ...state,
        volume: {
          ...state.volume,
          muted: payload,
        },
      }));
    },
  });
};

export default mediaSliceBuilder;
